var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('h1',[_vm._v("Contact")]),_c('el-card',[_vm._v(" follow with us on: "),_c('a',{attrs:{"target":"blank","href":"https://twitter.com/appform_llc"}},[_vm._v("Twitter @appform_llc")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }